import React, { FC } from 'react'

import { RotationRightButton } from "../../../../components/buttons/iconButtons/action/RotationCollection"
import { HighLightButton } from "../../../../components/buttons/iconButtons/editor/ActionCollection"
import { FilePlusButton } from "../../../../components/buttons/iconButtons/other/FileAndFolderCollection"
import { SquareMinusButton, SquarePlusButton } from '../../../../components/buttons/iconButtons/other/MailCollection'
import BaseCommandsPanel from "../../../../components/commandsPanels/BaseCommandsPanel"
import Tooltip from "../../../../components/tooltips/Tooltip"
import { UpIconButton } from '../../../../components/buttons/iconButtons/directions/ArrowsInCircleCollection'
import { checkActiveCommands } from '../../../CommonHelperFunctions'
import { useUserContext } from '../../../../system/providers/userContextProvider'
import { Button } from '../../../../components/buttons/button'
import { useTranslation } from 'react-i18next'

interface IPanelEvent {
    disabled?: boolean
    onClick: () => void
}
interface ICashRegistersCommandPanelProps {
    add?: IPanelEvent
    migration?: IPanelEvent
    centralOffice?: IPanelEvent
    edit?: IPanelEvent
    block?: IPanelEvent
    unBlock?: IPanelEvent
    refresh?: IPanelEvent
    permission?: IPermission
}

export const CompaniesCommandPanel: FC<ICashRegistersCommandPanelProps> = (props) => {

    const userContext = useUserContext();
    const activeCommands = checkActiveCommands(props.permission as IPermission, userContext.userPermission);
    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.companies.' + value)

    return (
        <BaseCommandsPanel groups={[

            [
                {
                    iconButton: <Tooltip title={baseT("addRecord")}>
                        <FilePlusButton sizeVariant="mini" {...{...props.add, disabled: props.add?.disabled || !activeCommands.add}} />
                    </Tooltip>
                },
                {
                    iconButton: <Tooltip title={baseT("editRecord")}>
                        <HighLightButton sizeVariant="mini" {...{...props.edit, disabled: props.edit?.disabled || !activeCommands.edit}} />
                    </Tooltip>
                },
                {
                    iconButton: <Tooltip title={baseT("runMigration")}>
                        <UpIconButton sizeVariant="mini" {...{...props.migration, disabled: props.migration?.disabled || !activeCommands.add}} />
                    </Tooltip>
                },
                {
                    iconButton: <Tooltip title={baseT("assignCentralOffice")}>
                        <Button variant="commandPanel" {...{...props.centralOffice, disabled: props.centralOffice?.disabled}}>Назначить ЦО</Button>
                    </Tooltip>
                },
            ],
            [
                {
                    iconButton: <Tooltip title={baseT("blockCompany")}>
                        <SquareMinusButton sizeVariant="mini" colorVariant='danger' {...{...props.block, disabled: props.block?.disabled || !activeCommands.add}} />
                    </Tooltip>
                },
                {
                    iconButton: <Tooltip title={baseT("unblockCompany")}>
                        <SquarePlusButton sizeVariant="mini" colorVariant='success' {...{...props.unBlock, disabled: props.unBlock?.disabled || !activeCommands.add}} />
                    </Tooltip>
                },
                {
                    iconButton: <Tooltip title={baseT("refresh")}>
                        <RotationRightButton sizeVariant="mini" {...{...props.refresh, disabled: props.refresh?.disabled || !activeCommands.refresh}} />
                    </Tooltip>
                }
            ]
        ]} />
    )
}